export const isMobilePage = (routes: { path?: string }[]): boolean => routes.some((route) => route.path === '/mobile');
